import { NgModule } from '@angular/core';
import { CalsoftSplashScreenService } from './splash-screen.service';

@NgModule({
    providers: [
        CalsoftSplashScreenService
    ]
})
export class CalsoftSplashScreenModule
{
    /**
     * Constructor
     *
     * @param {CalsoftSplashScreenService} _calsoftSplashScreenService
     */
    constructor(
        private _calsoftSplashScreenService: CalsoftSplashScreenService
    )
    {
    }
}
